import { render, staticRenderFns } from "./transferenciaJuegos.vue?vue&type=template&id=324a0918&scoped=true"
import script from "./transferenciaJuegos.vue?vue&type=script&lang=js"
export * from "./transferenciaJuegos.vue?vue&type=script&lang=js"
import style0 from "./transferenciaJuegos.vue?vue&type=style&index=0&id=324a0918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a0918",
  null
  
)

export default component.exports